module.exports = require("lodash/result");


//////////////////
// WEBPACK FOOTER
// external "lodash/result"
// module id = 41
// module chunks = 0